<template>
  <div :class="$style.container">
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item :label="$t('应用名称')">
              <a-input v-model="queryParams.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="handleRefresh(true)">{{ $t('查询') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="apps" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleAppCopy(record)">{{ $t('复制') }}</a>    
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
  </div>
</template>
<script>
import { getAppListForCurrentUser, saveApp, copyApp} from '@/api/app/app'
import { AppThemeOptions, AppStatusOptions } from '@/constants/AppConstants'
import { getLabelFromOptions } from '@/utils/dictUtils'

export default {
  data() {
    return {
      queryParams: {},
      apps: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('应用名称'),
          dataIndex: 'name',
          width: 200
        },
        {
          title: this.$t('应用描述'),
          dataIndex: 'remark',
        },
        {
          title: this.$t('应用ID'),
          dataIndex: 'appId',
        },
        {
          title: this.$t('应用密钥'),
          dataIndex: 'appSecret',
        },
        {
          title: this.$t('主题'),
          dataIndex: 'theme',
          customRender: (text) => {
            return getLabelFromOptions(text, AppThemeOptions)
          }
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          customRender: (text) => {
            return getLabelFromOptions(text, AppStatusOptions)
          }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted() {
    this.handleRefresh()
  },
  methods: {
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getAppListForCurrentUser({ ...params, templateType: '1' }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.apps = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleAppCopy(record) {
      this.$confirm({
        title: this.$t('确认复制应用吗？'),
        onOk: () => {
          copyApp({id: record.id}).then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('操作成功'))
            } else {
              this.$message.error(res.message || this.$t('操作失败'))
            }
          })
        }
      })
    },
    handleDelete(record) {
      saveApp({ id: record.id, templateType: '0' }).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" module>
.container {
  height: 100%;
  padding: 20px;
}
</style>